import React from "react";
import "./Card.css";

/**
 * Design-system Card — white surface, 12px radius, subtle border + shadow
 * (suggestion card, input bar shell, response containers).
 *
 * @param {boolean} padded  16px inner padding
 * @param {boolean} flat    no shadow
 * @param {string}  as      element type (default "div")
 */
const Card = React.forwardRef(function Card(
  { padded = false, flat = false, as: Tag = "div", className = "", children, ...rest },
  ref,
) {
  const classes = [
    "kc-card",
    padded ? "kc-card--padded" : "",
    flat ? "kc-card--flat" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag ref={ref} className={classes} {...rest}>
      {children}
    </Tag>
  );
});

export default Card;
